<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center pb-4">
      <img src="assets/img/svg/T.svg" alt="Tracy logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 align-self-start">
        <button type="button" class="btn-close" aria-label="Close" (click)="onDismissClick()">
        </button>
      </div>
    </div>
    <div class="body-wrapper">
      <form [formGroup]="inputForm">
        <div class="row">
          <div class="col-12 col-xl-6 pb-3">
            <!-- Registration/Start Number Type Label -->
            <div class="pb-3">
              <app-select formControlName="registrationFeeTypeId" [items]="registrationFeeTypes" valueKey="id"
                          labelKey="id"
                          labelKeyPrefix="race.pricing.raceCommercialItem.type."
                          label="race.pricing.raceCommercialItem.type"/>
            </div>
            <!-- Display Name Label -->
            <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [required]="true"
                                [extraLanguages]="getExtraLanguages()" [hrKey]="'name'" [enKey]="'nameEng'"
                                [itKey]="'nameIta'"
                                [siKey]="'nameSlo'" [hrLabel]="'race.pricing.raceCommercialItem.name'"
                                [enLabel]="'race.pricing.raceCommercialItem.name.en'"
                                [itLabel]="'race.pricing.raceCommercialItem.name.it'"
                                [siLabel]="'race.pricing.raceCommercialItem.name.sl'"/>
          </div>
          <div class="col-12 col-xl-6">
            <!-- Internal Description Textarea -->
            <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [required]="true"
                                [extraLanguages]="getExtraLanguages()" [hrKey]="'internalDescription'"
                                [enKey]="'internalDescriptionEng'" [itKey]="'internalDescriptionIta'"
                                [siKey]="'internalDescriptionSlo'"
                                [hrLabel]="'race.pricing.raceCommercialItem.description'"
                                [enLabel]="'race.pricing.raceCommercialItem.description.en'"
                                [itLabel]="'race.pricing.raceCommercialItem.description.it'"
                                [siLabel]="'race.pricing.raceCommercialItem.description.sl'" [isInput]="false"/>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6 pb-3">
            <app-input formControlName="vat" type="decimal" class="mb-3"
                       [translatedPlaceholder]="t('race.pricing.vatRate') + ' (%)'"
                       [translatedLabel]="t('race.pricing.vatRate') + ' (%)'"/>
            @if (inputForm.value.priceConstantByPeriod) {
              <div class="pt-3">
                <app-input formControlName="price" type="decimal" class="mb-3"
                           [translatedLabel]="t('race.pricing.price') +' (' + getCurrencyLabel() + ')'"
                           [translatedPlaceholder]="t('race.pricing.price') + ' (' + getCurrencyLabel() + ')'"/>
              </div>
            }
          </div>
          <div class="col-12 col-xl-6">
            <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [isInput]="false"
                                [required]="false" [extraLanguages]="getExtraLanguages()" [hrKey]="'vatExplanation'"
                                [enKey]="'vatExplanationEng'" [itKey]="'vatExplanationIta'"
                                [siKey]="'vatExplanationSlo'"
                                [hrLabel]="'race.pricing.vatRateExplanation'"
                                [enLabel]="'race.pricing.vatRateExplanation.en'"
                                [itLabel]="'race.pricing.vatRateExplanation.it'"
                                [siLabel]="'race.pricing.vatRateExplanation.sl'"/>

          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6">
            <!-- Same Price in All Periods -->
            <div class="form-floating">
              <div class="form-check form-switch mt-3 mb-3 d-flex align-items-center">
                <input class="form-check-input me-3" type="checkbox" formControlName="priceConstantByPeriod"
                       placeholder='{{t("race.pricing.samePrice")}}'>
                <label class="form-check-label">{{ t("race.pricing.samePrice") }}</label>
              </div>
            </div>
          </div>
        </div>

        @if (!inputForm.value.priceConstantByPeriod) {
          <div class="d-flex align-items-center justify-content-between">
          <span class="fw-bold text-uppercase">{{ t('race.pricing.priceByPeriodTitle') }}
          </span>
            <app-rounded-button [label]="t('race.pricing.addNewRegistrationPeriod')" (onClick)="addPeriod()"
                                [isDisabled]="disableEditing" [btnClass]="'rounded-button--solid'"><i
              class="bi bi-plus-circle pe-2"></i></app-rounded-button>
          </div>
        }
        @if (!inputForm.value.priceConstantByPeriod) {
          <ng-container formArrayName="periods">
            @if (overlappingPeriods.length > 0) {
              <p class="pt-4">
                <ngb-alert [dismissible]="false" class="warning-info">
                  <span>{{ t("race.pricing.item.error.periods.overlap") }}</span>
                  @for (overlapPair of overlappingPeriods;track overlapPair) {
                    <div class="">
                      <i class="bi bi-dot"></i>
                      ({{ overlapPair.period1.startDate | localizedDate:'shortDate' }}
                      -{{ overlapPair.period1.endDate | localizedDate:'shortDate' }})
                      {{ t("app.common.and") | lowercase }}
                      ({{ overlapPair.period2.startDate | localizedDate:'shortDate' }}
                      -{{ overlapPair.period2.endDate | localizedDate:'shortDate' }})
                    </div>
                  }
                </ngb-alert>
              </p>
            }
            @for (periodForm of periods.controls;track periodForm;let i = $index) {
              <ng-container [formGroupName]="i">
                @if (i > 0) {
                  <div class="field-title d-block d-lg-none pt-2">
                  </div>
                }
                <div class="row align-items-start pt-3">
                  <div class="col-12 col-lg-8">
                    <app-date-time-from-to-input [openDropdownUpwards]="true" formControlName="periodDates"
                                                 [displayRangeErrorBeforeTouched]="true"
                                                 [ranges]="{from: getDate(race?.registrationStart), to: getDate(race?.registrationEnd)}"
                                                 [invalidMessageKey]="'race.pricing.item.error.periods.range.error'"
                                                 [labelStart]="t('race.pricing.startOfPeriod')"
                                                 [labelEnd]="t('race.pricing.endOfPeriod')"
                                                 [displayTime]="false"/>
                  </div>
                  <div class="col-12 col-lg-3">
                    <app-input formControlName="price" id="price{{i}}" type="decimal"
                               [translatedLabel]="t('race.pricing.price') +' (' + getCurrencyLabel() + ')'"
                               [translatedPlaceholder]="t('race.pricing.price') + ' (' + getCurrencyLabel() + ')'"/>
                  </div>
                  <div class="col-lg-1 d-lg-flex d-none" [style.padding-top]="'32px'">
                    <div class="delete-icon" (click)="deletePeriod(i)"><i class="bi bi-trash-fill"></i></div>
                  </div>
                  <div class="d-flex justify-content-end align-items-end pt-2 d-block d-lg-none">
                    <button type="button" class="btn btn-min-height btn-small btn-text" style="font-size: medium;"
                            (click)="deletePeriod(i)">
                      <i class="bi bi-dash-circle pe-2"></i>{{
                        t("app.common.delete")
                      }}
                    </button>
                  </div>
                </div>
              </ng-container>
            }
          </ng-container>
        }
      </form>
    </div>
    <div class="d-flex justify-content-center align-items-center pb-40-48">
      <div class="d-flex">
        <div class="pe-3">
          <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--black-outline'"
                              (onClick)="onDismissClick()"/>
        </div>
        <app-rounded-button [label]="t('app.common.save')" (onClick)="onSave()"
                            [btnClass]="'rounded-button--solid'"></app-rounded-button>
      </div>
    </div>
  </div>
</ng-container>
